module.exports = __webpack_public_path__ + "img/dd2.cba2dddd.jpg";